import script from "./SecondView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecondView.vue?vue&type=script&setup=true&lang=ts"

import "./SecondView.vue?vue&type=style&index=0&id=7b18f27a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b18f27a"]])

export default __exports__